import { ActionReducerMap } from '@ngrx/store';
import { AuthState } from '../auth.state';
import { authReducer } from './auth.reducer';
import {orgReducer, searchOrgReducer} from './organization.reducer';
import { userReducer } from './user.reducer';

export const reducers: ActionReducerMap<AuthState> = {
    auth: authReducer,
    organization: orgReducer,
    user: userReducer,
    searchedOrganizations: searchOrgReducer
};
